export default {
  "menu.login": "Login",
  "menu.overview": "Overview",
  "menu.calendar": "Calendar",
  "menu.projects": "Projects",
  "menu.quality": "Quality",
  "menu.resources": "Resources",
  "menu.mindmaps": "Mind Maps",
  "menu.customers": "Customers",
  "menu.holidays": "Holidays",
  "menu.notifications": "Notifications",
  "menu.settings": "Settings",
  "menu.account.logout": "Logout",
};
